<div class="container-fluid browser-warning" *ngIf="notApproved">
  <div class="row">
    <div class="col-sm-12 text-center">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> <a href="{{browserURL}}" target="_blank"> Your browser is not recommended for use with this website.  <b>Click here</b> to see recommended browsers.</a>
    </div>
  </div>
</div>

